module.exports = __webpack_public_path__ + "media/images/university_logos/Loughborough-University-0672a6c197d60afbd974918761125c2e.svg";